import { updateGlobalSettings } from "./settings";
import { singularityStore } from "@/store/store";
import { BORDER_RADIUS_VALUES } from "@/types/singularity/brand";

export function updateGlobalButtonStyles(): void {
  const brandColors = singularityStore.brand.color;
  const radius = singularityStore.brand.ui.buttonRadius;

  const payload = {
    value: {
      primary: {
        corners: "custom",
        corner_radius: BORDER_RADIUS_VALUES[radius],
        background: `var(--${brandColors.primary?.base.cssVariableName})`,
        background_hover: `var(--${brandColors.primary?.scale[600].cssVariableName})`,
        typography: {
          color: `var(--${brandColors.primary?.text.cssVariableName})`
        }
      },
      secondary: {
        corners: "custom",
        corner_radius: BORDER_RADIUS_VALUES[radius],
        outline: "true",
        color: `var(--${brandColors.neutral?.scale[300].cssVariableName})`,
        typography: {
          color: `var(--${brandColors.neutral?.scale[900].cssVariableName})`
        }
      }
    }
  };

  updateGlobalSettings("settings.buttons", {
    ...payload.value
  });
}

export function updateGlobalFormStyles(): void {
  const radius = singularityStore.brand.ui.inputRadius;

  const payload = {
    value: {
      fields: {
        borders: {
          radius: {
            all: BORDER_RADIUS_VALUES[radius]
          }
        }
      }
    }
  };

  updateGlobalSettings("settings.forms", {
    ...payload.value
  });
}
